import api from './api';

const playerService = {
  getAllPlayers: async (filters = {}) => {
    const params = new URLSearchParams(filters);
    const response = await api.get(`/players?${params}`);
    return response.data;
  },

  getPlayerById: async (id) => {
    const response = await api.get(`/players/${id}`);
    return response.data;
  },

  createPlayer: async (playerData) => {
    const response = await api.post('/players', playerData);
    return response.data;
  },

  updatePlayer: async (id, playerData) => {
    const response = await api.put(`/players/${id}`, playerData);
    return response.data;
  },

  deletePlayer: async (id) => {
    const response = await api.delete(`/players/${id}`);
    return response.data;
  },

  getPlayerStats: async (id) => {
    const response = await api.get(`/players/${id}/stats`);
    return response.data;
  },

  getExternalData: async (id) => {
    const response = await api.get(`/players/${id}/external-data`);
    return response.data;
  },

  getClubGames: async (id) => {
    const response = await api.get(`/players/${id}/club-games`);
    return response.data;
  }
};

export default playerService;
